import { ApartmentOutlined, FilterOutlined, NumberOutlined } from "@ant-design/icons";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";

const generalClassName = ({
  disabled,
  textColor,
  memberType,
}: {
  disabled?: boolean;
  textColor?: string;
  memberType: "dimension" | "metric" | "filter";
}) => {
  return `${disabled ? "text-gray-200" : textColor ?? `text-[${getMemberColor(memberType).textColor}]`}  mr-2`;
};

const FilterIcon: React.FC<{ disabled?: boolean; textColor?: string }> = ({ disabled, textColor }) => {
  return <FilterOutlined className={generalClassName({ disabled, textColor, memberType: "filter" })} />;
};
const DimensionIcon: React.FC<{ disabled?: boolean; textColor?: string }> = ({ disabled, textColor }) => {
  return <ApartmentOutlined className={generalClassName({ disabled, textColor, memberType: "dimension" })} />;
};
const MeasureIcon: React.FC<{ disabled?: boolean; textColor?: string }> = ({ disabled, textColor }) => {
  return <NumberOutlined className={generalClassName({ disabled, textColor, memberType: "metric" })} />;
};

export { FilterIcon, DimensionIcon, MeasureIcon };
